import { useTranslation } from 'react-i18next'

import Text from '../../../../Text'
import { getMatchCriteria } from '../../RentalPortalMatch.utils'
import { MATCH_CRITERIA_POPOVER_COLUMN_TITLE_KEYS } from '../RentalPortalMatchCriteriaPopover.constants'
import { RentalPortalMatchCriteriaPopoverRow } from '../RentalPortalMatchCriteriaPopoverRow'

import * as styles from './RentalPortalMatchCriteriaPopoverCriteria.module.css'

function RentalPortalMatchCriteriaPopoverCriteria({ match }) {
  const { t } = useTranslation()

  return (
    <div className={styles.RentalPortalMatchCriteriaPopoverCriteria}>
      {MATCH_CRITERIA_POPOVER_COLUMN_TITLE_KEYS.map(titleKey => (
        <Text isSecondary className={styles.columnTitle} key={titleKey}>
          {t(titleKey)}
        </Text>
      ))}
      {getMatchCriteria(match).map(criterion => (
        <RentalPortalMatchCriteriaPopoverRow
          criterion={criterion}
          currency={match.currency}
          key={criterion.key}
        />
      ))}
    </div>
  )
}

export default RentalPortalMatchCriteriaPopoverCriteria
